import Immutable from 'immutable';
import {
  FLAG_GETTING_EXPENSES,
  GET_EXPENSES,
  CLEAR_EXPENSES,
  GET_EXPENSE,
  CLEAR_EXPENSE,
  FLAG_EXPENSE_ACTIVITY,
} from '../../../actions/types/sales/Expense';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_EXPENSES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_EXPENSES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_EXPENSES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_EXPENSE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_EXPENSE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_EXPENSE_ACTIVITY:
      // raising flag
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
